import Grid from '@mui/material/Grid';
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { ContextSelect } from '../../component/ContextSelect';
import { CountrySelector } from '../../component/CountrySelector';
import { FileInput } from '../../component/input/FileInput';
import { TextInput } from '../../component/input/TextInput';
import { SelectInput } from '../../component/input/SelectInput';
import { roles } from '../../helpers/InputDataForAddCustomer';
import CustomerAPI from '../../services/customer.api.service';
import useAlert from '../../component/Alert/useAlert';
import LoadingButton from '@mui/lab/LoadingButton';

export default function CreateCustomer() {
    const [customer, setCustomer] = useState({
        context: null,
        role: null,
        name: null,
        type: null,
        country: null,
        city: null,
        province: null,
        address: null,
        zip: null,
        document: null,
        url: null,
        representative_email: null,
        representative_phone: null,
        password: null,
    });

    const changeState = partialState => setCustomer(currentState => ({...currentState, ...partialState}));

    const [loading, setLoading] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(true);
    const {showSuccessAlert, showErrorAlert} = useAlert();

    async function handleSubmit() {
        setSubmit(true);
        if (customer.password !== confirmPassword) {
            return;
        }
        setLoading(true);
        try {
            await CustomerAPI.postCustomer(customer);
            showSuccessAlert('Successfully added');
            window.location.reload();
        } catch (err) {
            showErrorAlert(err.response.data.message);
        }
        setLoading(false);
    }

    return (
        <Paper sx={{p: 4, display: 'flex', alignItems: 'left'}}>
            <Grid container spacing={3}>
                <Grid item xs={0} md={2}></Grid>
                <Grid item xs={12} md={8}>
                    <Box sx={{width: '100%'}}>
                        <ContextSelect
                            onContextChange={context => changeState({context: context.id})}
                        />
                        <SelectInput
                            label="Company Role"
                            options={roles}
                            onChange={role => changeState({role: role})}
                            error={submit && !customer.role}
                        />
                        <TextInput
                            placeholder="Company Name *"
                            onChange={name => changeState({name})}
                            error={submit && !customer.name}
                        />
                        <TextInput
                            placeholder="Company Type (AG, LTD, SA, etc..) *"
                            onChange={type => changeState({type})}
                            error={submit && !customer.type}
                        />
                        <CountrySelector
                            label="Country of Residence"
                            onChange={country => changeState({country: country.code})}
                            error={submit && !customer.country}
                        />
                        <TextInput
                            placeholder="Company City Of Residence *"
                            onChange={city => changeState({city})}
                            error={submit && !customer.city}
                        />
                        <TextInput
                            placeholder="Company Province Of Residence *"
                            onChange={province => changeState({province})}
                            error={submit && !customer.province}
                        />
                        <TextInput
                            placeholder="Company Address *"
                            onChange={address => changeState({address})}
                            error={submit && !customer.address}
                        />
                        <TextInput
                            placeholder="Company Address Postal Code *"
                            onChange={zip => changeState({zip})}
                            error={submit && !customer.zip}
                        />
                        <TextInput
                            placeholder="Company URL"
                            onChange={url => changeState({url})}
                            error={submit && !customer.url}
                            required={false}
                        />
                        <FileInput
                            label="ProofOfIdentity Document (PDF, PNG, etc..) *"
                            onChange={document => changeState({document})}
                            accept=".pdf, .docx, .png, .jpeg"
                            error={submit && !customer.document}
                        />
                        <TextInput
                            placeholder="Company representative email *"
                            onChange={representative_email => changeState({representative_email})}
                            error={submit && !customer.representative_email}
                        />
                        <TextInput
                            placeholder="Company representative phone number"
                            onChange={representative_phone => changeState({representative_phone})}
                            required={false}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            error={submit && !customer.password}
                            label="Password"
                            type="password"
                            id="password"
                            onChange={event => changeState({password: event.target.value})}
                            size="small"
                            sx={{mb: 1, mt: 1}}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="confirmPassword"
                            label="Confirm Password"
                            type="password"
                            id="confirmPassword"
                            error={submit && confirmPassword !== customer.password}
                            helperText={(submit && confirmPassword === customer.password) ? '' : 'Passwords do not match'}
                            onChange={event => setConfirmPassword(event.target.value)}
                            size="small"
                            sx={{mb: 1, mt: 1}}
                        />
                        <LoadingButton
                            sx={{mt: 1}}
                            fullWidth
                            loading={loading}
                            variant="contained"
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            <span>Add</span>
                        </LoadingButton>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
}
